import { render, staticRenderFns } from "./VaBadge.demo.vue?vue&type=template&id=42118497&"
import script from "./VaBadge.demo.vue?vue&type=script&lang=js&"
export * from "./VaBadge.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports